import React from "react";
import ContentManagement from "../ContentManagement/ContentManagement";
import informationManagementService from "../../services/InformationManagementService";
import { CONTENT_TYPES_CONFIG } from "../../config/App.config";

const InformationSection = () => {
  return (
    <ContentManagement
      service={informationManagementService}
      pageSize={10}
      sidebarItemLayout="horizontal"
      // use the information section title as the slug
      getSlug="title"
      contentType={CONTENT_TYPES_CONFIG.INFORMATION}
    />
  );
};

export default InformationSection;